export enum ApiType {
    application = "application",
    authorization = "authorization"
}
